import { Box, DialogTitle, IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ArrowLeftOMIcon, CloseOMIcon } from '@omnea-app/icons'

type Props = {
  title: string
  onClose?: () => void
  /** Set when the dialog navigates within itself, so the title can be stepped back out of. */
  onBack?: () => void
  /** Use while a save is in flight, so the dialog cannot be dismissed mid-mutation. */
  disabled?: boolean
}

/** Dialog counterpart of DrawerHeader: the themed DialogTitle with a close affordance pushed to the end. */
export const DialogHeader = ({ title, onClose, onBack, disabled }: Props) => {
  const { t } = useTranslation('common')

  return (
    <DialogTitle sx={{ alignItems: 'center', gap: 2 }}>
      {onBack && (
        <IconButton onClick={onBack} size="medium" aria-label={t('dialog.back')} disabled={disabled}>
          <ArrowLeftOMIcon />
        </IconButton>
      )}
      {/* Shrinkable, so an arbitrarily long title ellipsizes rather than squeezing the close button */}
      <Box component="span" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {title}
      </Box>
      {onClose && (
        <IconButton onClick={onClose} size="medium" aria-label={t('dialog.close')} disabled={disabled} sx={{ ml: 'auto' }}>
          <CloseOMIcon />
        </IconButton>
      )}
    </DialogTitle>
  )
}
